import { HOMEPAGE } from '@/config/router';
import DashboardLayout from '@/layouts/dashboard';
import PageError from '@/pages/sys/error/PageError';
import LoginPage from '@/pages/sys/login';
import ProtectedRoute from '@/router/components/protected-route';
import { usePermissionRoutes } from '@/router/hooks';
import { ERROR_ROUTE } from '@/router/routes/error-routes';
import { ErrorBoundary } from 'react-error-boundary';
import { Navigate, type RouteObject, createHashRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import type { AppRouteObject } from '#/router';
import LoginSuccessPage from '@/pages/sys/login/login-success-page';

const PUBLIC_ROUTE: AppRouteObject = {
  path: '/login',
  element: (
    <ErrorBoundary FallbackComponent={PageError}>
      <LoginPage />
    </ErrorBoundary>
  ),
};

const LOGIN_SUCCESS_ROUTE: AppRouteObject = {
  path: '/login-success',
  element: <LoginSuccessPage />,
};

const NO_MATCHED_ROUTE: AppRouteObject = {
  path: '*',
  element: <Navigate to="/404" replace />,
};

export default function Router() {
  const permissionRoutes = usePermissionRoutes();

  const PROTECTED_ROUTE: AppRouteObject = {
    path: '/',
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [{ index: true, element: <Navigate to={HOMEPAGE} replace /> }, ...permissionRoutes],
  };

  const routes = [
    PUBLIC_ROUTE,
    LOGIN_SUCCESS_ROUTE,
    PROTECTED_ROUTE,
    ERROR_ROUTE,
    NO_MATCHED_ROUTE,
  ] as RouteObject[];

  const router = createHashRouter(routes);

  return <RouterProvider router={router} />;
}
